/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { useActions as useActionsUtil } from '../../utils/actions';
import { initialState } from './reducers';

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		initialise: (state, { payload }) => {
			const {
				isAuthenticated,
				authenticatedUser = null,
				accessToken = null,
				idToken = null,
			} = payload;

			state.isAuthenticated = isAuthenticated;
			state.isInitialised = true;
			state.authenticatedUser = authenticatedUser;
			state.accessToken = accessToken || state.accessToken;
			state.idToken = idToken || state.idToken;
		},
		login: (state, { payload }) => {
			state.isAuthenticated = true;
			state.authenticatedUser = payload.authenticatedUser;
		},
		logout: (state) => {
			state.isAuthenticated = false;
			state.isImpersonating = false;
			state.impersonatedUser = null;
			state.authenticatedUser = null;
			state.accessToken = undefined;
			state.idToken = undefined;
		},
		impersonate: (state, { payload }) => {
			state.isImpersonating = true;
			state.impersonatedUser = payload.impersonatedUser;
		},
		endImpersonation: (state) => {
			state.isImpersonating = false;
			state.impersonatedUser = null;
		},
		setAccessToken: (state, { payload }) => {
			state.accessToken = payload;
		},
		setIdToken: (state, { payload }) => {
			state.idToken = payload;
		},
		updateSecret: (state, { payload }) => {
			if (state.isImpersonating && state.impersonatedUser) {
				state.impersonatedUser.userSecret = payload;
				return;
			}

			if (state.authenticatedUser) {
				state.authenticatedUser.userSecret = payload;
			}
		},
	},
});

export const useActions = () => useActionsUtil(authSlice.actions);
export default authSlice;
export const { actions, reducer } = authSlice;
